import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	dismiss: {
		id: 'oauth-message-dismiss',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the oauth message',
	},
});
